export const menus = [
    // {
    //     id: 1014,
    //     title: "Menu",
    //     route_name: 'menu',
    //     icon: "fas fa-ellipsis-h",
    // },

    // {
    //     id: 1041,
    //     title: "Kateqoriyalar",
    //     route_name: 'category',
    //     icon: "fas fa-list",
    // },

    // {
    //     id: 1092,
    //     title: "Rollar",
    //     route_name: 'roles',
    //     icon: "fas fa-user-check",
    // },
    // {
    //     id: 1094,
    //     title: "Istifadəçilər",
    //     route_name: 'users',
    //     icon: "fas fa-users",
    // },
    {
        id: 100,
        title: "Əsas səhifə",
        name: "main_pages",
        icon: "fas fa-home",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 101,
                title: "Dashboard",
                route_name: 'dashboard',
                icon: "fas fa-th",
                // link: "/dashboard",
            },
            // {
            //     id: 102,
            //     title: "Dashboard 2",
            //     route_name: 'dashboard2',
            //     icon: "fas fa-th",
            //     // link: "/dashboard",
            // },


            {
                id: 103,
                title: "-",
                role: "user",
            },

            {
                id: 104,
                title: "Menu",
                route_name: 'menu',
                icon: "fas fa-ellipsis-h",
                // link: "/menu",
            },
            {
                id: 105,
                title: "Banner",
                route_name: 'banner',
                icon: "fas fa-chalkboard",
                // link: "/products",
            },
            // {
            //     id: 105,
            //     title: "Statistika",
            //     route_name: 'statistics',
            //     icon: "far fa-chart-bar",
            //     // link: "/products",
            // },
            {
                id: 106,
                title: "Kateqoriya",
                route_name: 'category',
                icon: "fas fa-object-group",
                // link: "/category",
            },
            // {
            //     id: 107,
            //     title: "Bilirsinizmi",
            //     route_name: 'doyouknow',
            //     icon: "far fa-question-circle",
            //     // link: "/category",
            // },
            // {
            //     id: 108,
            //     title: "Məhsullar",
            //     route_name: 'products',
            //     icon: "fas fa-list",
            //     // link: "/products",
            // },
            {
                id: 109,
                title: "Texno yazarlar",
                name: 'authors',
                route_name: 'authors',
                icon: "fas fa-user-graduate",
                // link: "/author",
            },
            {
                id: 110,
                title: "Mövzular",
                name: 'posts',
                route_name: 'posts',
                icon: "fas fa-list",
                // link: "/posts",
            },
            {
                id: 111,
                title: "Layihələr",
                // name: 'tv',
                route_name: 'projects',
                icon: "fas fa-list",
                // link: "/posts",
            },
            {
                id: 112,
                title: "Sosial şəbəkələr",
                route_name: 'social_network',
                icon: "fas fa-network-wired",
                // link: "/social_network",
            },
            {
                id: 113,
                title: "Məktublar",
                route_name: 'contact',
                icon: "far fa-envelope",
            },
        ]
    },
    {
        id: 150,
        title: "Sistem",
        name: "system",
        icon: "fas fa-user-cog",
        collapsed: true,
        visible: true,
        items: [
            // {
            //     id: 151,
            //     title: "Filter qrupu",
            //     route_name: 'filter',
            //     name: 'filter_groups',
            //     icon: "fas fa-filter",
            //     // link: "/manufacturer",
            // },
            // {
            //     id: 152,
            //     title: "İstehsalçı",
            //     route_name: 'manufacturer',
            //     icon: "fas fa-industry",
            //     // link: "/manufacturer",
            // },

            {
                id: 155,
                title: "-",
                // role: "user",
            },

            {
                id: 156,
                title: "Rollar",
                route_name: 'roles',
                icon: "fas fa-user-check",
                // link: "/role",
            },
            {
                id: 157,
                title: "Istifadəçilər",
                route_name: 'users',
                icon: "fas fa-users",
                // link: "/user",
            },
        /*]
    },
    {
        id: 200,
        title: 'Sazlama',
        icon: 'fas fa-cogs',
        collapsed: true,
        visible: true,
        items: [*/
            {
                id: 201,
                title: "Terminlər",
                route_name: 'terms',
                name: 'terms',
                icon: "fas fa-language",
                // link: "/language",
            },
            {
                id: 202,
                title: "Dillər",
                route_name: 'languages',
                name: 'languages',
                icon: "fas fa-flag",
                // link: "/language",
            },
            {
                id: 203,
                title: "Sistem",
                route_name: 'settings',
                icon: "fas fa-cog",
                // link: "/system",
            },
        ],
    },
    {
        id: 250,
        title: "Məlumat",
        name: "info",
        icon: "fas fa-info-circle",
        collapsed: true,
        visible: true,
        items: [
            {
                id: 251,
                title: "Profilim",
                route_name: 'profile',
                icon: "fas fa-user",
                // link: "/profile",
            },
            {
                id: 252,
                title: "About",
                route_name: 'about',
                icon: "fas fa-info-circle",
                // link: "/about",
            },
        ]
    }
];
